import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { ADMIN_URL } from '@prcins/constants';

@Injectable({
  providedIn: 'root'
})
export class PackageComparisonService {

  constructor(private http: HttpClient) { }

  getPackageComparisonData(state: string): Observable<any> {
   return this.http.get<any>(`${ADMIN_URL.getPackageComparisonData}/${state}`);
  }

  savePackageComparisonData(state: string, payload: any): Observable<any> {
    return this.http.post<any>(`${ADMIN_URL.savePackageComparisonData}/${state}`, payload);
  }
}